import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "Who we are",
    body: "Comprehensive Chain Management (Pty) Ltd, trading as CompCar Motors (\"CompCar\", \"we\", \"us\"), is the responsible party for personal information processed through this website, our applications and our rental, rent-to-own and sales services.",
  },
  {
    title: "What we collect",
    body: "Identity and contact details (name, ID or passport number, phone, email, address), driver's licence details, employment and income information, affordability and expense figures, banking details for debit-order purposes, supporting documents you upload (ID copy, licence, proof of income), and vehicle usage preferences.",
  },
  {
    title: "Why we process it",
    body: "To assess eligibility and affordability, verify identity and income, prepare quotations and consumer agreements, administer rental and rent-to-own agreements, process debit orders, comply with the National Credit Act and other laws, and communicate with you about your enquiry or agreement.",
  },
  {
    title: "Lawful basis",
    body: "We process your information with your consent (given in our application declarations), to take steps before and during a contract with you, and to comply with legal obligations.",
  },
  {
    title: "Who we share it with",
    body: "Only what is necessary, with: verification and credit assessment providers, payment and debit-order processors, tracking and insurance partners where applicable, and regulators or law enforcement when legally required. We never sell your personal information.",
  },
  {
    title: "How we protect it",
    body: "Access is restricted to authorised staff, documents are stored in access-controlled storage, and sensitive files (such as your ID copy) are never publicly accessible. We retain information only as long as needed for the purposes above or as required by law.",
  },
  {
    title: "Your rights",
    body: "You may request access to, correction of, or deletion of your personal information, object to processing, or withdraw consent where processing is based on consent. You also have the right to complain to the Information Regulator (South Africa).",
  },
  {
    title: "Contact our information officer",
    body: "Email admin@compcarmotors.co.za or call 010 534 9926. Office 10A, 136 North Rand Road, Jansen Park, Boksburg.",
  },
];

export default function Popia() {
  return (
    <div data-testid="popia-page" className="pt-32 pb-24 min-h-screen">
      <div className="w-full max-w-3xl mx-auto px-4 sm:px-6">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-sky-300 font-bold mb-4">Your privacy</p>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tight font-black text-white mb-4">
            POPIA privacy notice.
          </h1>
          <p className="text-base text-slate-400 mb-14">
            How CompCar Motors collects, uses and protects your personal
            information under the Protection of Personal Information Act, 2013.
          </p>
        </Reveal>
        <div className="space-y-4">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={Math.min(i * 0.05, 0.3)}>
              <div data-testid={`popia-section-${i}`} className="bg-[#122659]/60 border border-sky-300/20 rounded-xl p-7">
                <h2 className="font-display text-lg font-bold text-white mb-2">{s.title}</h2>
                <p className="text-sm text-slate-400 leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="text-xs text-slate-600 mt-10">Last updated: August 2026.</p>
      </div>
    </div>
  );
}
